(() => {
  const parsed = new WeakMap();
  const read = node => {
    if (!node) return null;
    if (!parsed.has(node)) parsed.set(node,JSON.parse(node.textContent));
    return parsed.get(node);
  };
  const element = (tag,className,text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function catalog() {
    const products = new Map();
    document.querySelectorAll('[data-vr-cart-product]').forEach(node=>{
      const product = read(node);
      Object.entries(product.variants).forEach(([id,variant])=>products.set(Number(id),{
        title:product.title,variant:variant.title,price:variant.price,image:variant.image || product.image,
        promoModel:product.promoModel,url:product.url,options:(product.optionNames || []).map((name,index)=>({name,value:variant.options?.[index]}))
      }));
    });
    document.querySelectorAll('[data-accessory-card]').forEach(card=>{
      const image = card.querySelector('img');
      products.set(Number(card.dataset.variantId),{
        title:card.querySelector('.vr-accessory-card__title')?.textContent.trim(),
        variant:card.querySelector('.vr-accessory-card__variant')?.textContent.trim(),
        price:Number(card.dataset.price),image:image?.currentSrc || image?.src
      });
    });
    document.querySelectorAll('product-form form').forEach(form=>{
      window.ConsoleAddons?.getForForm(form)?.selectedAddons().forEach(({group,value,addon})=>{
        products.set(Number(String(addon.variant_id).split('/').pop()),{
          title:group.key==='storage' ? value+' '+group.label : value,
          price:Number(addon.price),image:''
        });
      });
    });
    document.querySelectorAll('[data-vr-cart-upgrade-products]').forEach(node=>{
      read(node).forEach(product=>product.variants.forEach(variant=>{
        if (!products.has(Number(variant.id)) || !product.title) return;
        Object.assign(products.get(Number(variant.id)),{title:product.title,variant:variant.title,image:variant.image || product.image});
      }));
    });
    return products;
  }
  function giftDetails(gift) {
    const config = window.VRExperiments?.config;
    const source = Object.entries(read(document.getElementById('vr-included-config'))?.map || {}).find(([,value])=>value.id===gift.id)?.[0];
    const entry = Object.entries(config?.includedAccessories || {}).find(([,value])=>Number(value.variantId)===Number(source));
    const handle = entry?.[0] || '';
    const data = entry?.[1];
    const labels = config?.includedLabels || {};
    const title = handle==='3ds-ladekabel' ? labels.cable3ds : handle==='usb-c-ladekabel' ? labels.cableUsb : handle==='3-ersatz-stifte-fur-den-3ds-xl' ? labels.stylus : gift.title;
    return {...gift,title:title || gift.title,retail:data?.price ?? gift.price,price:0,
      image:data?.image?.replace(/width=\d+/,'width=120'),included:true,
      prefixQuantity:!(/(?:32gb|128gb|storage-)/.test(handle) || /SD-Karte/.test(gift.title)),
      storage32:handle==='32gb-speicher'};
  }
  function incoming(items) {
    if (!items?.length || items.some(item=>item.selling_plan)) return null;
    const products = catalog();
    const gifts = Object.values(read(document.getElementById('vr-included-config'))?.map || {});
    const details = items.map(item=>{
      const gift = item.properties?._bundle_kind==='included' && gifts.find(g=>g.id===Number(item.id));
      const product = gift ? giftDetails(gift) : products.get(Number(item.id));
      return product && Number.isFinite(product.price) && product.title
        ? {...product,...item,id:Number(item.id),quantity:Number(item.quantity || 1),children:[]} : null;
    });
    if (details.some(item=>!item)) return null;
    const roots = details.filter(item=>!item.parent_id && !item.parent_line_key);
    for (const child of details.filter(item=>item.parent_id || item.parent_line_key)) {
      const parent = roots.find(root=>root.id===Number(child.parent_id));
      if (!parent) return null;
      parent.children.push(child);
    }
    for (const parent of roots) {
      const plan = window.VRCartPlan?.giftPlan(parent,items);
      if (plan) for (const id of plan) {
        if (parent.children.some(child=>child.id===id)) continue;
        const gift = gifts.find(g=>g.id===id);
        if (gift) parent.children.push({...giftDetails(gift),quantity:parent.quantity});
      }
      parent.children.sort((a,b)=>Number(Boolean(b.included))-Number(Boolean(a.included)));
    }
    return roots;
  }
  function money(value,format,currency) {
    if (!format) return new Intl.NumberFormat(document.documentElement.lang || 'de',{style:'currency',currency:currency || 'EUR'}).format(value/100);
    const text = format.replace(/\{\{\s*(\w+)\s*\}\}/g,(_,token)=>{
      const digits=token.includes('no_decimals') ? 0 : 2;
      const comma=token.includes('comma_separator');
      const parts=(value/100).toFixed(digits).split('.');
      const separator=token.includes('apostrophe') ? "'" : token.includes('space') ? ' ' : comma ? '.' : ',';
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,separator)+(digits ? (comma ? ',' : '.')+parts[1] : '');
    });
    const holder=document.createElement('span'); holder.innerHTML=text; return holder.textContent;
  }
  function cleanClone(node) {
    const clone=node.cloneNode(true);
    [clone,...clone.querySelectorAll('*')].forEach(item=>['id','for','form','aria-controls','aria-describedby','aria-labelledby','headers'].forEach(name=>item.removeAttribute(name)));
    return clone;
  }
  function show(items,trigger) {
    const panel = document.querySelector('cart-drawer');
    const source = read(panel?.querySelector('[data-vr-cart-view]'));
    const rowTemplate=panel?.querySelector('[data-vr-cart-row-template]');
    const originalFooter=panel?.querySelector('.drawer__inner > .drawer__footer') || panel?.querySelector('.drawer__footer');
    if (!source || !rowTemplate || !originalFooter) return;
    const added = incoming(items);
    if (!added) return;
    clear();
    const cart = window.VRCheckoutContents?.snapshot?.cart || {items:source.items,total_price:source.total};
    const formats=read(panel.querySelector('[data-vr-cart-display]')) || {};
    const format=value=>money(value,formats.money,source.currency);
    const stage = element('div','vr-cart-preview');
    stage.dataset.vrCartPreview = '';
    stage.inert=true;
    const content=element('div','vr-cart-preview__items');
    const contents=element('div','drawer__contents');
    const wrapper=element('div','drawer__cart-items-wrapper');
    const table=element('table','cart-items'); table.setAttribute('role','table');
    const list=element('tbody',''); list.setAttribute('role','rowgroup'); table.append(list); wrapper.append(table); contents.append(wrapper); content.append(contents);
    const draw = item => {
      const row=rowTemplate.content.querySelector('tr').cloneNode(true);
      const image=row.querySelector('.cart-item__image');
      if (item.image) {image.src=item.image;image.alt=item.title;} else image.remove();
      const name=row.querySelector('.cart-item__name'); name.textContent=item.title; if(item.url)name.href=item.url;
      row.querySelector('[data-preview-base-price]').textContent=format(item.price*item.quantity);
      const options=row.querySelector('[data-preview-options]');
      const appendOption=(name,value)=>{const option=element('div','product-option');option.append(element('dt','',name+':'),document.createTextNode(' '),element('dd','',value));options.append(option);};
      (item.options || []).filter(option=>option.name!=='Title' && option.value).forEach((option,index,array)=>appendOption(option.name,option.value+(index<array.length-1?', ':'')));
      const groupFor={Speicher:'storage',Storage:'storage',Mod:'hardware','Hardware-Modifikation':'hardware','Hardware modification':'hardware',Akku:'battery',Battery:'battery'};
      Object.entries(item.properties || {}).filter(([key,value])=>!key.startsWith('_') && key!=='Je Konsole gratis' && key.toLowerCase()!=='status' && value
        && !(groupFor[key]==='storage' && item.children.some(child=>child.storage32))
        && !item.children.some(child=>child.properties?._bundle_kind===groupFor[key] && groupFor[key])
      ).forEach(([key,value])=>appendOption(key,value));
      if (!options.childElementCount) options.remove();
      const upgrades=row.querySelector('.vr-cart-upgrades__list');
      for (const child of item.children.filter(child=>!child.promo)) {
        const line=element('li','vr-cart-upgrade');
        const media=element('div','vr-cart-upgrade__image');
        if (child.image) {const img=element('img','');img.src=child.image;img.alt='';img.width=60;img.height=60;media.append(img);}
        const copy=element('div','vr-cart-upgrade__copy');
        copy.append(element('span','vr-cart-upgrade__name',(child.prefixQuantity?child.quantity+' × ':'')+child.title));
        if(child.variant && child.variant!=='Default Title' && !child.title.includes(child.variant)) copy.append(element('span','vr-cart-upgrade__variant',child.variant));
        const price=element('span','vr-cart-upgrade__price');
        if (child.retail>child.price) price.append(element('s','vr-cart-retail-price',format(child.retail*child.quantity)),document.createTextNode(' '));
        price.append(document.createTextNode(format(child.price*child.quantity)));
        line.append(media,copy,price); upgrades.append(line);
      }
      if (!item.children.length) upgrades.parentElement.remove();
      const sum=item.price*item.quantity+item.children.reduce((total,child)=>total+child.price*child.quantity,0);
      const retail=item.price*item.quantity+item.children.reduce((total,child)=>total+(child.retail ?? child.price)*child.quantity,0);
      const oldPrice=row.querySelector('[data-preview-retail]');if(retail>sum)oldPrice.textContent=format(retail);else oldPrice.remove();
      row.querySelector('[data-preview-price]').textContent=format(sum);
      row.querySelector('.quantity__input').value=String(item.quantity);
      window.VR3DSPromo?.appendCart(row,item);
      list.append(row);
    };
    added.forEach(draw);
    panel.querySelectorAll('cart-drawer-items .cart-items tbody > .cart-item').forEach(row=>list.append(cleanClone(row)));
    const recommendations=panel.querySelector('cart-drawer-items .vr-accessories-cart');
    if (recommendations) wrapper.append(cleanClone(recommendations));
    const delta = added.reduce((sum,item)=>sum+item.price*item.quantity+item.children.reduce((total,child)=>total+child.price*child.quantity,0),0);
    const total=cart.total_price+delta;
    const retail=cart.items.reduce((sum,item)=>sum+(item.original_line_price ?? (item.original_price ?? item.final_price)*item.quantity),0)
      +added.reduce((sum,item)=>sum+item.price*item.quantity+item.children.reduce((amount,child)=>amount+(child.retail ?? child.price)*child.quantity,0),0);
    const footer=cleanClone(originalFooter);
    footer.classList.add('vr-cart-preview__footer');
    footer.querySelector('.totals__total-value').textContent=money(total,formats.moneyWithCurrency,source.currency);
    footer.querySelector('.vr-cart-savings')?.remove();
    const savingsTemplate=panel.querySelector('[data-vr-cart-savings-template]');
    if (retail>total && savingsTemplate) {
      const savings=savingsTemplate.content.firstElementChild.cloneNode(true);
      savings.querySelector('s').textContent=format(retail);
      savings.querySelector('.vr-cart-savings__saved dd').textContent=format(retail-total);
      footer.querySelector('.totals').after(savings);
    }
    footer.querySelectorAll('button').forEach(button=>{button.disabled=false;button.type='button';});
    const status=element('p','visually-hidden',source.labels.saving); status.setAttribute('role','status');
    stage.append(content,footer,status);
    panel.querySelector('.drawer__header').after(stage);
    panel.classList.add('vr-cart-optimistic');
    return clear;
  }
  let undoRemoval;
  function remove(data) {
    const panel=document.querySelector('cart-drawer');
    const source=read(panel?.querySelector('[data-vr-cart-view]'));
    if (!source?.items?.length) return;
    const items=source.items;
    const resolveKey=value=>{
      const exact=items.find(item=>item.key===String(value));
      if(exact)return exact.key;
      const variants=items.filter(item=>String(item.id)===String(value));
      return variants.length===1 ? variants[0].key : null;
    };
    let keys;
    if(data.updates && !Array.isArray(data.updates)) {
      const entries=Object.entries(data.updates);
      if(!entries.length || entries.some(([,quantity])=>Number(quantity)!==0))return;
      keys=entries.map(([key])=>resolveKey(key));
    } else if(data.quantity !== undefined && Number(data.quantity)===0) {
      keys=[data.id !== undefined ? resolveKey(data.id) : items[Number(data.line)-1]?.key];
    } else return;
    if(keys.some(key=>!key))return;
    const removed=new Set(keys);
    const parentOf=item=>source.parents?.[item.key] || item.parent_relationship?.parent_key || item.parent_relationship?.parent?.key;
    // Shopify removes nested children with their parent; reflect the whole bundle immediately.
    for(let pass=0;pass<items.length;pass++) {
      const count=removed.size;
      items.forEach(item=>{if(removed.has(parentOf(item)))removed.add(item.key);});
      if(removed.size===count)break;
    }
    const remaining=items.filter(item=>!removed.has(item.key));
    const values=read(panel.querySelector('[data-vr-cart-line-values]')) || {};
    const finalValue=item=>values[item.key]?.final ?? item.final_line_price ?? item.final_price*item.quantity;
    const retailValue=item=>values[item.key]?.retail ?? item.original_line_price ?? item.original_price*item.quantity;
    const delta=items.filter(item=>removed.has(item.key)).reduce((sum,item)=>sum+finalValue(item),0);
    const total=remaining.length ? Math.max(0,source.total-delta) : 0;
    const retail=remaining.reduce((sum,item)=>sum+retailValue(item),0);
    if(!Number.isFinite(total) || !Number.isFinite(retail))return;
    const rows=[...document.querySelectorAll('cart-drawer-items .cart-item, cart-items .cart-item')];
    const affected=rows.filter(row=>removed.has(row.querySelector('[data-cart-line-key]')?.dataset.cartLineKey));
    if(!affected.length)return;
    const emptyTemplate=panel.querySelector('[data-vr-cart-empty-template]');
    if(!remaining.length && !emptyTemplate)return;
    clear();
    const undo=[];
    undoRemoval=()=>{for(const restore of undo.reverse())restore();};
    const hide=node=>{if(!node)return;const old=node.getAttribute('style');undo.push(()=>old===null?node.removeAttribute('style'):node.setAttribute('style',old));node.style.display='none';};
    const text=(node,value)=>{if(!node)return;const old=node.textContent;undo.push(()=>node.textContent=old);node.textContent=value;};
    const toggle=(node,name,value)=>{if(!node)return;const old=node.classList.contains(name);undo.push(()=>node.classList.toggle(name,old));node.classList.toggle(name,value);};
    affected.forEach(hide);
    document.querySelectorAll('[data-vr-cart-accessories]').forEach(block=>{
      const cards=[...block.querySelectorAll('[data-accessory-card]')];
      const obsolete=cards.filter(card=>card.dataset.parentHandle && !remaining.some(item=>item.handle===card.dataset.parentHandle));
      obsolete.forEach(hide);
      if(cards.length && obsolete.length===cards.length)hide(block);
    });
    toggle(panel,'vr-cart-removing',true);
    const formats=read(panel.querySelector('[data-vr-cart-display]')) || {};
    document.querySelectorAll('cart-drawer .drawer__footer, #main-cart-footer').forEach(footer=>{
      text(footer.querySelector('.totals__total-value'),money(total,formats.moneyWithCurrency,source.currency));
      const savings=footer.querySelector('.vr-cart-savings');
      if(retail>total) {
        text(savings?.querySelector('s'),money(retail,formats.money,source.currency));
        text(savings?.querySelector('.vr-cart-savings__saved dd'),money(retail-total,formats.money,source.currency));
      } else hide(savings);
    });
    const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble');
    const visibleCount=remaining.filter(item=>!(parentOf(item) && (item.properties?._bundle_hidden==='true' || item.handle==='128gb-speicher-upgrade-fur-nintendo-3ds'))).reduce((sum,item)=>sum+item.quantity,0);
    if(!visibleCount)hide(bubble);
    else {
      text(bubble?.querySelector('[aria-hidden="true"]'),visibleCount<100?String(visibleCount):'');
      const accessible=bubble?.querySelector('.visually-hidden');
      if(accessible)text(accessible,accessible.textContent.replace(/\d+/,String(visibleCount)));
    }
    if(!remaining.length) {
      const empty=emptyTemplate.content.firstElementChild.cloneNode(true);
      panel.querySelector('.drawer__inner').prepend(empty);
      undo.push(()=>empty.remove());
      toggle(panel,'is-empty',true);
      toggle(document.querySelector('cart-items'),'is-empty',true);
      toggle(document.getElementById('main-cart-footer'),'is-empty',true);
      hide(panel.querySelector('cart-drawer-items'));
      hide(panel.querySelector('.drawer__footer'));
    }
    return clear;
  }
  function clear() {
    const restore=undoRemoval;
    undoRemoval=null;
    restore?.();
    const panel = document.querySelector('cart-drawer');
    panel?.classList.remove('vr-cart-optimistic');
    panel?.querySelector('[data-vr-cart-preview]')?.remove();
  }
  window.VRCartPreview = {show,remove,clear,incoming};
  const warmed=new Set();
  const warm = () => {
    try {
      const products=catalog();
      const images=new Set();
      document.querySelectorAll('product-form form input[name="id"]').forEach(input=>images.add(products.get(Number(input.value))?.image));
      Object.values(window.VRExperiments?.config?.includedAccessories || {}).forEach(item=>images.add(item.image?.replace(/width=\d+/,'width=120')));
      document.querySelectorAll('[data-vr-cart-upgrade-products]').forEach(node=>read(node).forEach(product=>images.add(product.image)));
      if (window.Image) images.forEach(src=>{if(src && !warmed.has(src)){warmed.add(src);const image=new window.Image();image.src=src;}});
    } catch (_) {}
  };
  document.addEventListener('console-addons:change',warm);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',warm,{once:true});
  else warm();
})();

